import { Card } from "react-bootstrap";
import * as R from "ramda";
import React from "react";
import { StateSetter } from "../../../utils/types";
import { MdClose } from "react-icons/md";
import { IconButton } from "../../IconButton";
import "./Tray.scss";
import { InfoProps } from "../InfoSidebar";
import Markdown from "markdown-to-jsx";

interface TrayProps {
  infoList: InfoProps[];
  setShowExpandedTray: StateSetter<boolean>;
}

const Tray: React.FC<TrayProps> = ({ infoList, setShowExpandedTray }) => {

  return (
    <>
      <Card className="trayContainer">
        <Card.Header className="trayHeader">
          <div className="trayTextAndButton">
            <div className="trayText">File Requirements</div>
            <div className="widgetBox">
              <IconButton
                className="trayCloseButtonBox"
                variant="outline-white"
                onClick={() => setShowExpandedTray(false)}
                icon={<MdClose className="trayCloseButton" />}
              >
                {""}
              </IconButton>
            </div>
          </div>
        </Card.Header>
        <Card.Body className="trayBody">
          {infoList &&
            R.map(
              info => (
                <>
                  <div className="infoTitle">{info.title}</div>
                  <div className="infoContent"><Markdown>{info.content}</Markdown></div>

                </>
              ),
              infoList
            )}
        </Card.Body>
      </Card>
    </>
  );
};

export default Tray;
